import { disableXrayIcon } from '../state/ui-store';

export const disableXrayBttn = () => disableXrayIcon();
